import { BackBtnProps } from '../../../types/props'
import BackBtnImg from '../../../assets/images/be-v1/back.png'

const BackBtn = ({ handleBackClick }: BackBtnProps) => {
  return (
    <img
      className='engagement__action--back-btn'
      src={BackBtnImg}
      alt='back'
      onClick={handleBackClick}
    />
  )
}

export default BackBtn
